(() => {
  const KEY = "wl_handles_v1";

  const uniq = (arr) => Array.from(new Set(arr.filter(Boolean)));

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
    catch { return []; }
  }

  function setList(list) {
    localStorage.setItem(KEY, JSON.stringify(uniq(list)));
    window.dispatchEvent(new CustomEvent("wishlist:updated"));
  }

  function hasHandle(handle) {
    return getList().includes(handle);
  }

  function toggleHandle(handle) {
    const list = getList();
    const i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1);
    else list.push(handle);
    setList(list);
    return i < 0;
  }

  function bindHearts(root = document) {
    root.querySelectorAll("[data-wl-btn]").forEach((btn) => {
      if (btn.dataset.wlBound === "1") return;
      btn.dataset.wlBound = "1";

      const handle = btn.getAttribute("data-wl-handle");
      const refresh = () => {
        const active = hasHandle(handle);
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      };

      refresh();

      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleHandle(handle);
        refresh();
      });

      window.addEventListener("wishlist:updated", refresh);
    });
  }

  // --- Wishlist Page rendering ---
  function formatMoney(cents, moneyFormat) {
    // Very small formatter compatible with Shopify's {{ shop.money_format }}
    const value = (cents / 100).toFixed(2);
    if (!moneyFormat) return value;
    return moneyFormat.replace("{{amount}}", value)
      .replace("{{ amount }}", value)
      .replace("{{amount_no_decimals}}", Math.round(cents/100).toString())
      .replace("{{ amount_no_decimals }}", Math.round(cents/100).toString());
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error("Fetch failed: " + handle);
    return await res.json();
  }

  async function renderWishlistPage() {
    const page = document.querySelector("[data-wl-page]");
    if (!page) return;

    const grid = page.querySelector("[data-wl-grid]");
    const empty = page.querySelector("[data-wl-empty]");
    const moneyFormat = page.getAttribute("data-money-format") || "";

    const list = getList();
    if (!list.length) {
      empty.style.display = "";
      grid.innerHTML = "";
      return;
    }

    empty.style.display = "none";
    grid.innerHTML = "<p>Loading...</p>";

    const products = await Promise.allSettled(list.map(fetchProduct));
    const ok = products
      .filter(p => p.status === "fulfilled")
      .map(p => p.value);

    if (!ok.length) {
      empty.style.display = "";
      grid.innerHTML = "";
      return;
    }

    grid.innerHTML = ok.map((p) => {
      const img = (p.images && p.images[0]) ? p.images[0] : "";
      const price = formatMoney(p.price, moneyFormat);

      return `
        <div class="wl-item" data-handle="${p.handle}">
          <a href="${p.url}">
            ${img ? `<img class="wl-img" src="${img}" alt="${p.title}">` : `<div class="wl-img"></div>`}
            <div class="wl-title">${p.title}</div>
            <div class="wl-price">${price}</div>
          </a>
          <div class="wl-row">
            <button class="wl-btn" type="button" aria-pressed="true" data-wl-btn data-wl-handle="${p.handle}" title="Remove from wishlist">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path class="wl-heart" d="M12 21s-7-4.6-9.5-8.7C.8 9 .9 5.9 3.2 4.2 5.6 2.4 8.6 3.1 10.4 5c.6.6 1.1 1.3 1.6 2 .5-.7 1-1.4 1.6-2 1.8-1.9 4.8-2.6 7.2-.8 2.3 1.7 2.4 4.8.7 8.1C19 16.4 12 21 12 21z"/>
              </svg>
            </button>
            <button class="wl-remove" type="button" data-wl-remove="${p.handle}">Remove</button>
          </div>
        </div>
      `;
    }).join("");

    // Bind remove buttons
    grid.querySelectorAll("[data-wl-remove]").forEach((b) => {
      b.addEventListener("click", () => {
        const handle = b.getAttribute("data-wl-remove");
        setList(getList().filter(h => h !== handle));
        renderWishlistPage();
      });
    });

    // Bind hearts inside wishlist page
    bindHearts(page);
  }

  // Re-bind after dynamic section loads (Shopify theme editor / ajax)
  document.addEventListener("DOMContentLoaded", () => {
    bindHearts(document);
    renderWishlistPage();
  });

  document.addEventListener("shopify:section:load", (e) => {
    bindHearts(e.target);
  });

  window.addEventListener("wishlist:updated", () => {
    renderWishlistPage();
    bindHearts(document);
  });
})();
